import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  Form,
  CardBody,
  CardTitle,
} from "reactstrap"
import Dropzone from "react-dropzone"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "store/actions";

import { Link } from "react-router-dom"

interface BreadcrumbItem {
  title: string;
  link: string;
}

interface FormUploadProps {
  setBreadcrumbItems: (title: string, items: BreadcrumbItem[]) => void;
}

const FormUpload = (props: FormUploadProps) => {

  document.title = "Form File Upload | Lexa - Responsive Bootstrap 5 Admin Dashboard";

  const breadcrumbItems = [
    { title: "Lexa", link: "#" },
    { title: "Forms", link: "#" },
    { title: "File Upload", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems('File Upload', breadcrumbItems)
  })

  interface FileWithPreview extends File {
    preview?: string;
    formattedSize?: string;
  }

  const [selectedFiles, setselectedFiles] = useState<FileWithPreview[]>([])

  function handleAcceptedFiles(files: File[]) {
    const filesWithPreview = files.map((file: File) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(filesWithPreview)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <React.Fragment>

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <CardTitle className="h4">Dropzone</CardTitle>
              <p className="card-title-desc">
                DropzoneJS is an open source library that provides
                drag’n’drop file uploads with image previews.
                  </p>
              <Form>
                <Dropzone
                  onDrop={acceptedFiles => {
                    handleAcceptedFiles(acceptedFiles)
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone dz-clickable">
                      <div
                        className="dz-message needsclick"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="mdi mdi-cloud-upload-outline text-muted display-4"></i>
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3" id="file-previews">
                  {selectedFiles.map((f: FileWithPreview, i: number) => {
                    return (
                      <Card
                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                        key={i + "-file"}
                      >
                        <div className="p-2">
                          <Row className="align-items-center">
                            <Col className="col-auto">
                              <img
                                data-dz-thumbnail=""
                                height="80"
                                className="avatar-sm rounded bg-light"
                                alt={f.name}
                                src={f.preview}
                              />
                            </Col>
                            <Col>
                              <Link
                                to="#"
                                className="text-muted font-weight-bold"
                              >
                                {f.name}
                              </Link>
                              <p className="mb-0">
                                <strong>{f.formattedSize}</strong>
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    )
                  })}
                </div>
              </Form>

              <div className="text-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light"
                >
                  Send Files
                    </button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(FormUpload);